import React from 'react';
import { Provider } from 'react-redux';

import irmsStore from './redux/irmsStore';

export default class IrmsContainer extends React.Component {
  Component = null;

  constructor(props) {
    super(props);
    const { component } = props;
    this.Component = require(`./${component}`).default;
  }

  render () {
    // @ts-ignore
    const { component, ...props } = this.props;
    const Component = this.Component;

    return (
      <Provider store={irmsStore}>
        <Component {...props} />
      </Provider>
    );
  }
}
